import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatOptionSelectionChange } from "@angular/material/core";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-dropdown-enum',
    templateUrl: './dropdown-enum.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropDownEnumComponent {
    @Input() public form: FormGroup;
    @Input() public nameForControl: string;
    @Input() public dataEnum: any;
    @Input() public labelName: string;
    @Input() public hideLabel: boolean;
    @Input() public autoTranslate: boolean = true;

    @Output() public emitSelected: EventEmitter<any> = new EventEmitter();

    constructor(
        public helperService: HelperService
    ) {
    }

    public onChange(event: MatOptionSelectionChange): void {
        if (event.isUserInput) {
            this.emitSelected.emit(event.source.value);
        }
    }
}
